import type { FlagsMapper } from '@atlassian/jira-flags';
import {
	ADD_COMPONENT_SUCCESS,
	ADD_COMPONENT_FAIL,
	DELETE_COMPONENT_SUCCESS,
	DELETE_COMPONENT_FAILURE,
	UPDATE_COMPONENT_SUCCESS,
	UPDATE_COMPONENT_FAIL,
	INITIATE_UPDATE_COMPONENT_FAIL,
	type AddComponentSuccessAction,
	type AddComponentFailAction,
	type UpdateComponentSuccessAction,
	type UpdateComponentFailAction,
	type DeleteComponentSuccessAction,
	type DeleteComponentFailureAction,
	type InitiateUpdateComponentFailAction,
} from '../state/actions.tsx';
import type { State } from '../state/reducer.tsx';
import AddError from './add/error.tsx';
import AddSuccess from './add/success.tsx';
import DeleteError from './delete/error.tsx';
import DeleteSuccess from './delete/success.tsx';
import UpdateError from './update/error.tsx';
import UpdateInitiateError from './update/initiate-error.tsx';
import UpdateSuccess from './update/success.tsx';

type Action =
	| InitiateUpdateComponentFailAction
	| AddComponentSuccessAction
	| AddComponentFailAction
	| UpdateComponentSuccessAction
	| UpdateComponentFailAction
	| DeleteComponentSuccessAction
	| DeleteComponentFailureAction;

const flagsMapper: FlagsMapper<Action, State> = (action) => {
	switch (action.type) {
		case ADD_COMPONENT_SUCCESS:
			return AddSuccess(action.payload.name);

		case ADD_COMPONENT_FAIL: {
			return AddError();
		}

		case DELETE_COMPONENT_SUCCESS: {
			return DeleteSuccess(action.payload.component.name);
		}

		case DELETE_COMPONENT_FAILURE: {
			return DeleteError();
		}

		case UPDATE_COMPONENT_SUCCESS: {
			return UpdateSuccess(action.payload.componentName);
		}

		case UPDATE_COMPONENT_FAIL: {
			return UpdateError();
		}

		case INITIATE_UPDATE_COMPONENT_FAIL: {
			return UpdateInitiateError();
		}
		default: {
			const _exhaustiveCheck: never = action;
			return undefined;
		}
	}
};

export default flagsMapper;
